import { createFileRoute } from "@tanstack/react-router";
import AdminErrors from "@/pages/admin/AdminErrors";

export const Route = createFileRoute("/admin/erreurs")({
  component: AdminErrors,
});
